import React from 'react';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { ProjectVersionsComponent } from '@atlassian/jira-project-versions/src/ui/index.tsx';
import { useRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import { projectVersionsRelayResource } from '@atlassian/jira-router-resources-project-versions/src/controllers/index.tsx';
import AddProjectToHistory from '@atlassian/jira-spa-apps-common/src/add-project-to-history/index.tsx';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/sub-product-updater/index.tsx';
import { PageLayout } from '@atlassian/jira-spa-apps-page-layout/src/page/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';

type Props = {
	projectKey?: string;
};

const RelayVersions = ({ projectKey }: Props): React.JSX.Element => {
	const { queryReference } = useRelayResource(projectVersionsRelayResource);

	if (!projectKey) {
		throw new Error('Unable to find projectkey');
	}

	return (
		<PageLayout>
			<MarkProductStart />
			<SubProductUpdater subProduct="platform" />
			{queryReference && <ProjectVersionsComponent queryReference={queryReference} />}
			<AddProjectToHistory projectKey={projectKey} />
			<SpaStatePageReady />
		</PageLayout>
	);
};

export default AnalyticsSource('project-versions', SCREEN)(RelayVersions);
